module.exports = __webpack_public_path__ + "img/GR017N.40c689c9.png";